import { CircleAlert, Wallet } from "lucide-react";

import { Link } from "react-router-dom";
import nookPayLogo from "@src/assets/Favicon.png";
import useLoginCallback from "./use-login-callback";

const LoginCallback = () => {
  const { status, email } = useLoginCallback();

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy px-4">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-white p-6 text-center shadow-2xl shadow-black/40 sm:p-7">
        <div className="mb-6 flex items-center justify-center gap-2.5">
          <img
            src={nookPayLogo}
            alt="NookPay"
            className="h-10 w-10 rounded-xl object-cover shadow-lg shadow-accent/30"
          />
          <span className="text-lg font-semibold tracking-tight text-gray-900">
            NookPay
          </span>
        </div>

        {status === "verifying" && (
          <>
            <div className="mx-auto mb-4 h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-accent" />
            <div className="text-xl font-semibold tracking-tight text-gray-900">
              Signing you in&hellip;
            </div>
            <p className="mt-1 text-sm text-muted">
              {email ? `Verifying ${email}` : "Verifying your sign-in link"}
            </p>
          </>
        )}

        {status === "error" && (
          <>
            <span className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-danger/10 text-danger">
              <CircleAlert size={24} />
            </span>
            <div className="text-xl font-semibold tracking-tight text-gray-900">
              This link isn&apos;t valid
            </div>
            <p className="mt-1 text-sm text-muted">
              It may have expired or already been used. Request a new sign-in
              link to continue.
            </p>
            <Link
              to="/login"
              className="mt-6 inline-flex h-9 w-full items-center justify-center gap-1.5 rounded-md bg-primary px-4 py-2 text-sm font-medium text-white shadow transition-colors hover:bg-primary/90"
            >
              Back to sign in
            </Link>
          </>
        )}

        {status === "success" && (
          <>
            <span className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-success/10 text-success">
              <Wallet size={22} />
            </span>
            <div className="text-xl font-semibold tracking-tight text-gray-900">
              You&apos;re signed in
            </div>
            <p className="mt-1 text-sm text-muted">
              Redirecting you to your workspace&hellip;
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default LoginCallback;
